import {Link, Navigate, useParams} from "react-router-dom";
import BasicInformationTab from "./BasicInformationTab";
import CreditTransactionsTab from "./CreditTransactionsTab";
import PasswordChangeTab from "./PasswordChangeTab";
import KYCInformationTab from "./KYCInformationTab";

const TABS = [
    {slug: 'basic-information', label: 'Basic Information', icon: 'mdi-account', Component: BasicInformationTab},
    {slug: 'kyc-information', label: 'KYC Information', icon: 'mdi-office-building', Component: KYCInformationTab},
    {slug: 'credit-transactions', label: 'Credit Points & Credit Transactions', icon: 'mdi-bank', Component: CreditTransactionsTab},
    {slug: 'password-change', label: 'Password Change', icon: 'mdi-email-variant', Component: PasswordChangeTab},
];

function AccountPage() {
    const {tab} = useParams();
    const active = TABS.find((t) => t.slug === tab);
    if (!active) {
        return <Navigate to={`/account/${TABS[0].slug}`} replace />;
    }
    const ActiveComponent = active.Component;

    return (
        <>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card-box">
                        <ul className="nav nav-tabs nav-bordered">
                            {TABS.map((t) => (
                                <li className="nav-item" key={t.slug}>
                                    <Link to={`/account/${t.slug}`}
                                          className={`nav-link ${active.slug === t.slug ? 'active' : ''}`}>
                                        <span className="d-inline-block d-sm-none"><i className={`mdi ${t.icon}`}/></span>
                                        <span className="d-none d-sm-inline-block">{t.label}</span>
                                    </Link>
                                </li>
                            ))}
                        </ul>
                        <div className="tab-content">
                            <ActiveComponent />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AccountPage;
